import type { ComponentProps } from "react";

import { cn } from "~/shared/ui";
import { Skeleton } from "~/shared/ui/skeleton";

type Props = ComponentProps<typeof Skeleton>;

function CalculatorCardSkeleton({ className, ...props }: Props) {
  return <Skeleton className={cn("h-[39.625rem]", className)} {...props} />;
}
export { CalculatorCardSkeleton };
